define('app/views/show_more_coupons',['app/setup', 'app/models/deal_card', 'app/collections/deal_collection'],
  function (takhfifan, dealCard, dealCollection) {

    takhfifan.showMoreCoupons = Backbone.View.extend({
      events: {
        'click .tkh-load-more-coupon__trigger': 'loadMore'
      },

      template: ($('#coupon-list-template').length > 0) ?
        _.template($('#coupon-list-template').html()) : '',


      initialize: function () {
        this.collection = new takhfifan.DealCardCollection;
        this.collection.entityId = this.$el.data('entityId');
        this.collection.type = this.$el.data('type');
        this.collection.offset = this.$el.parent('.tkh-latest-dc-body').find('.latest-dc-item').length;
        this.collection.nextPage = 1;
        this.collection.limit = 8;
        this.$el.find('.tkh-load-more-coupon__trigger').css('visibility', 'visible');
        var _this = this;

        var automaticLoad = _.debounce(function () {
          if (_this.activateAutoLoad && _this.isOnViewport()) {
            _this.loadMore();
          }
        }, 300);

        this.activateAutoLoad = false;

        $(window).scroll(automaticLoad);

      },

      isOnViewport: function () {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = this.$el.offset().top;
        var elemBottom = elemTop + this.$el.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
      },

      loadMore: function () {
        var _this = this;
        if (this.collection.nextPage === -1) {
          this.activateAutoLoad = false;
          return;
        }
        this.$el.addClass('loading-view');
        var url = '/ajax/productlist/recentProducts?categoryId=' + this.collection.entityId
                          + '&offset='+ this.collection.offset
                          + '&limit='+ this.collection.limit;
        $.ajax({
          url: url,
          type: "GET"
        }).done(function (response) {
          if(response.success){
            if(response.data.length){
              _this.$el.before(_this.template({
                coupons: response.data
              }));
              _this.collection.offset = $('.tkh-latest-dc-body').find('.latest-dc-item').length;
              _this.checkUrl = $('#tkh-check-customer-can-buy-url').val();
              $('.tkh-latest-dc-item').each(function () {
                new takhfifan.DiscountLastsItemView({el: $(this) , checkUrl: _this.checkUrl});
              });
            }
            else{
              _this.$el.find('.tkh-load-more-coupon__trigger').css('display', 'none');
            }
          }
          _this.$el.removeClass('loading-view');
        });
      }
    })
  });

